export default __webpack_public_path__ + "static/media/todd-kelly-cv_2021.896034c5.pdf";